import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./Sidebar.module.css";
import Button from "./Button";
import MainMenu from "../menus/MainMenu";

function logout() {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");
  localStorage.removeItem("userLogin");
  window.location.href = "/login";
}

function Sidebar({ children }) {
  const userData = JSON.parse(localStorage.getItem("userLogin"));

  return (
    <aside className={styles.sidebar}>
      <div className={styles.website}>
        <h1>Banquetscheduler</h1>
      </div>
      <div className={styles.logo}>
        <img src="/logo192.png" />
      </div>
      {children}
      <div className={styles.user}>
        <p>User: {userData.user}</p>
        <Button type="primary" onClick={logout}>
          Logout
        </Button>
      </div>
      <footer className={styles.footer}>
        <p className={styles.copyright}>&copy;{new Date().getFullYear()} by SFL Software</p>
      </footer>
    </aside>
  );
}

export default Sidebar;
